import angular from 'angular';

import User from '../../models/user';
import Case from '../../models/case';
import AccountModel from '../../models/account';
import CurrentCustomer from '../../models/customer';
import AccountMap from '../../models/account-map';

import PaymentStatusServ from '../../services/payment-status';
import AnalyticsServ from '../../services/analytics';
import ReloadServ from '../../services/reload';
import ClioServ from '../../services/clio';

import CreateCaseModalConf from '../../modals/create-case';
import ReferralModalConf from '../../modals/referral';
import SubscriptionStatusModalConf from '../../modals/subscription-status';
import AccountSetupModalConf from '../../modals/account-setup';
import WelcomeModalConf from '../../modals/welcome';
import PaymentEnable from '../payment-enable';

import NavbarCtrl from './navbar.controller';

function adminNav() {
  return {
    restrict: 'A',
    template: require('./navbar.html'),
    controller: NavbarCtrl,
    link: function (scope) {
      // scrollable-content directive watches this var
      // which is set to true when rendered
      scope.adminNavRendered = true;

    }
  };
}

export default angular.module('directives.admin-nav', [User,
    PaymentEnable, Case, PaymentStatusServ, CreateCaseModalConf,
    ReferralModalConf, AccountMap, AccountModel, CurrentCustomer,
    AnalyticsServ,
    AccountSetupModalConf, SubscriptionStatusModalConf,
    WelcomeModalConf, ReloadServ, ClioServ
  ])
  .directive('adminNav', adminNav)
  .name;



// WEBPACK FOOTER //
// ./project/directives/admin-nav/index.js